import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import {
    useImageLoading,
    SkeletonLoading,
    useIdentificationContext,
    Variant,
} from '@fiverr-private/identification_core';
import { responsiveImg } from '../../../shared/styles/index.ve.css';
import { appTranslate } from '../../../i18n';
import withBubblesImage from '../../../assets/with_bubbles.png';
import goWithBubblesImage from '../../../assets/go_with_bubbles.png';

const getIllustrationImage = (variant: Variant) => {
    switch (variant) {
        case 'go':
            return goWithBubblesImage;
        case 'default':
        default:
            return withBubblesImage;
    }
};

export const WithBubblesIllustration = () => {
    const { variant } = useIdentificationContext();
    const imageSrc = getIllustrationImage(variant);
    const { loading, onLoad } = useImageLoading(imageSrc);

    return (
        <SkeletonLoading loading={loading}>
            <Container position="relative" height="100%" width="100%">
                <img
                    onLoad={onLoad}
                    alt={appTranslate<string>('identification.banner.image_alt')}
                    className={responsiveImg}
                    src={imageSrc}
                />
            </Container>
        </SkeletonLoading>
    );
};
